export const getScrollTriggerVerticalOptions = (
  node: HTMLElement,
  reverse: boolean,
  start = 'top 92%'
) => ({
  scrollTrigger: {
    trigger: node,
    once: !reverse,
    start,
    markers: false,
    horizontal: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }
})

export const getScrollTriggerHorizontalOptions = (
  node: HTMLElement,
  reverse: boolean,
  start = 'left 92%'
) => ({
  scrollTrigger: {
    trigger: node,
    once: !reverse,
    start,
    markers: false,
    horizontal: true,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }
})

export const isElementInViewport = (node: HTMLElement, horizontal: boolean) => {
  const bbox = node.getBoundingClientRect()
  return horizontal
    ? bbox.left < window.innerWidth
    : bbox.top < window.innerHeight
}
